import { useEffect } from 'react';

declare global {
  interface Window {
    Cal?: any;
  }
}

export function ContactForm() {
  useEffect(() => {
    // Cal.com inline embed initialization
    (function (C: any, A: string, L: string) {
      let p = function (a: any, ar: any) { a.q.push(ar); };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api: any = function () { p(api, arguments); };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");

    if (window.Cal) {
      window.Cal("init", "poly-digital-workforce", { origin: "https://app.cal.com" });

      window.Cal.ns["poly-digital-workforce"]("inline", {
        elementOrSelector: "#my-cal-inline-poly-digital-workforce",
        config: { layout: "month_view" },
        calLink: "princeps/poly-digital-workforce",
      });

      window.Cal.ns["poly-digital-workforce"]("ui", {
        cssVarsPerTheme: {
          light: { "cal-brand": "#292929" },
          dark: { "cal-brand": "#fafafa" }
        },
        hideEventTypeDetails: true,
        layout: "month_view"
      });
    }
  }, []);

  return (
    <div className="flex flex-col gap-4">
      <h3 className="font-heading text-xl text-foreground">15 Minutes. Zero Pressure.</h3>
      <p className="font-body text-sm text-muted-foreground mb-2">
        See which digital workers, teams, or departments fit your business. Monthly salary, included work budget, output guaranteed.
      </p>
      <div
        id="my-cal-inline-poly-digital-workforce"
        className="w-full h-[500px] overflow-auto rounded-xl border border-border bg-background"
      />
    </div>
  );
}